import axios from 'axios';

interface User {
  email: string;
  password: string;
}

interface Item {
  name: string;
}

interface Category {
  name: string;
}

interface Type {
  name: string;
  price: number;
  cost: number | null;
  measurementUnit: string | null;
}

const sansanTech = {
  signIn: (user: User) => {
    return axios({
      method: 'post',
      url: 'api/v1/sessions',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        user: {
          email: user.email.toLowerCase(),
          password: user.password,
        },
      },
    });
  },

  signUp: (user: User) => {
    return axios({
      method: 'post',
      url: 'api/v1/registrations',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        user: {
          email: user.email.toLowerCase(),
          password: user.password,
        },
      },
    });
  },

  getItems: (token: string) => {
    return axios({
      method: 'get',
      url: 'api/v1/items',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getItem: (token: string, itemId: number) => {
    return axios({
      method: 'get',
      url: `api/v1/items/${itemId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  },

  createItem: (token: string, item: Item) => {
    return axios({
      method: 'post',
      url: 'api/v1/items',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        item: {
          name: item.name,
        },
      },
    });
  },

  updateItem: (token: string, itemId: number, item: Item) => {
    return axios({
      method: 'patch',
      url: `api/v1/items/${itemId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        item: {
          name: item.name,
        },
      },
    });
  },

  createCategory: (token: string, itemId: number, category: Category) => {
    return axios({
      method: 'post',
      url: `api/v1/categories/${itemId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        category: {
          name: category.name,
        },
      },
    });
  },

  updateCategory: (token: string, categoryId: number, category: Category) => {
    return axios({
      method: 'patch',
      url: `api/v1/categories/${categoryId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        category: {
          name: category.name,
        },
      },
    });
  },

  createType: (token: string, categoryId: number, type: Type) => {
    return axios({
      method: 'post',
      url: `api/v1/types/${categoryId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        type: {
          name: type.name,
          price: type.price,
          cost: type.cost,
          measurement_unit: type.measurementUnit,
        },
      },
    });
  },

  updateType: (token: string, typeId: number, type: Type) => {
    return axios({
      method: 'patch',
      url: `api/v1/types/${typeId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        type: {
          name: type.name,
          price: type.price,
          cost: type.cost,
          measurement_unit: type.measurementUnit,
        },
      },
    });
  },
};

export default sansanTech;
